import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { OutingService } from 'src/app/outing/outing.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { SessionService } from 'src/app/shared/services/session.service';
import { Course } from '../../course/course';
import { OutingList } from '../models/outing.list';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-outing-iteration-create',
    templateUrl: './outing-iteration-create.component.html',
    styleUrls: ['./outing-iteration-create.component.scss'],
    standalone: false
})
export class OutingIterationCreateComponent extends BaseComponent{
  public outing: OutingList;
  public courses: Course[] = [];
  public addCourse: boolean = false;
  public form = new FormGroup({
    outingId: new FormControl('', {
      validators: Validators.required
    }),
    startDateOnly: new FormControl(),
    startTimeOnly: new FormControl(),
    startDate: new FormControl(),
    cost: new FormControl(0, {
      validators: [Validators.required, Validators.min(0)]
    }),
    courseId: new FormControl(),
    createdBy: new FormControl(),
    registrationCode: new FormControl('', {
      validators: Validators.required
    })
  });

  public filteredCourses: Observable<Course[]>;

  constructor(sessionService: SessionService,
    private route: ActivatedRoute,
    private router: Router,
    private outingService: OutingService,
    stringHelpers: StringHelpers,
    public dialog: MatDialog) {
    super(sessionService,
      stringHelpers);
    this.outing = this.getSearchKey(this.route.snapshot.paramMap.get('id')) as OutingList;
    this.form.get('outingId').patchValue(this.outing.id);
    this.generateRegistrationCode();
  }

  onSubmit({ value, valid }) {
    if (valid) {
      this.isLoading = true;
      const { startDateOnly, startTimeOnly, ...rest } = value;
      const payload = {
        ...rest,
        outingId: this.outing.id,
        courseId: value.courseId.id,
        createdBy: this.sessionService.getUserId(),
        startDate: this.combineDateAndTime(startDateOnly, startTimeOnly)
      };
      this.outingService.createOutingIteration(payload).subscribe(() => {
        this.isLoading = false;
        this.form.reset();
        this.form.clearAsyncValidators();
        this.form.clearValidators();
        this.isLoading = false;
        this.router.navigate(['/outing-management/administration/outing/iterations']);
      }, (err: any) => {
        this.isLoading = false;
        this.setError(err, this.form);
      });
    }
  }

  /** Same pattern as `outing-create` `setDateTime`: date from datepicker + time from timepicker → one `Date`. */
  private combineDateAndTime(dateOnly: Date | string | null | undefined, timeOnly: Date | string | null | undefined): Date {
    const d = new Date(dateOnly as Date | string);
    const t = timeOnly instanceof Date ? timeOnly : new Date(timeOnly as string);
    return new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds()
    );
  }

  generateRegistrationCode() {
    this.form.get('registrationCode').patchValue((Math.random() + 1).toString(36).substring(6).toUpperCase());
  }

  setCourseId(courseId: any){
    this.form.get('courseId').patchValue(courseId);
  }
}
